export const equalHeight = (element) => {
  const elements = Array.from(document.querySelectorAll(element));
  const allHeights = [];

  elements.forEach((el, i) => {
    el.style.height = "auto";
    allHeights.push(el.clientHeight);
  });

  elements.forEach((el, i) => {
    el.style.height = Math.max.apply(Math, allHeights) + "px";
  });
};
